/// 埋点统计
import { post } from '@/services/fetch'

// 0表示落地页访问，1表示下载app入口展示，2直接访问app，3访问app模板详情，4落地页用户进入模板点击使用
export const countLandingPageDayLog = (event) => post('/api/v1/countLandingPageDayLog', event)
